var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';
var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton');
var ReUpText = require('./ReUpText');
var ReUpField = require('./ReUpField')
var MKSegmentControl = require('./MKSegmentControl')
var NetworkManager = require('./NetworkManager')
var ArcMeter = require('./ArcMeter.js')
var FadingView = require('./FadingView.js')


var MK = require('./wrappers/react-native-material-kit-wrapper');

var Share = require('./wrappers/react-native-share-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  StyleSheet,
  Easing
} = ReactNative;

var EarnPoints = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
      referTitle: null
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      campaigns : [],
      useCreditCampaign : null,
      referCampaign : null,
      checkInCampaign : null,
      transferLoyaltyCampaign : null,
      vipCampaign : null,
      birthdayCampaign : null,
      starZoom : new Animated.Value(1)
    }
  },

  _didShowTransferLoyalty : false,
  componentDidMount : function()
  {
    if( this.props.extras && this.props.extras.shouldShowTransfer )
    {
      if( this.state.transferLoyaltyCampaign != null ) this.showLoyaltyTransfer();
    }
    else if( this.props.extras && this.props.extras.shouldShowVIP  )
    {
      if( this.state.vipCampaign != null ) this.showVIPProgress({Blob:this.state.vipCampaign});
    }
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {
    if( typeof data.Campaigns !== 'undefined' )
    {
      var useCreditCampaign = null;
      var referCampaign = null;
      var checkInCampaign = null;
      var transferLoyaltyCampaign = null;
      var vipCampaign = null;
      var birthdayCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        try {
        var campaign = data.Campaigns[i];
          if( campaign.Type == "UseCredit" ) useCreditCampaign = JSON.parse(campaign.CampaignBlob);
          if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
          if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
          if( campaign.Type == "TransferLoyalty" ) transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
          if( campaign.Type == "VIP" ) vipCampaign = JSON.parse(campaign.CampaignBlob);
          if( campaign.Type == "Birthday" ) birthdayCampaign = JSON.parse(campaign.CampaignBlob);
        }
        catch(e)
        {

        }
      }
      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0};
      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};
      if( !this._didShowTransferLoyalty && this.props.extras && this.props.extras.shouldShowTransfer && transferLoyaltyCampaign )
      {
        this.state.transferLoyaltyCampaign = transferLoyaltyCampaign;
        this.showLoyaltyTransfer();
      }
      else if( !this._didShowVIPProgress && this.props.extras && this.props.extras.shouldShowVIP && vipCampaign )
      {
        this.state.vipCampaign = vipCampaign;
        this.showVIPProgress({Blob:vipCampaign});
      }

      this.setState({
        campaigns:data.Campaigns,
        useCreditCampaign,
        referCampaign,
        checkInCampaign,
        transferLoyaltyCampaign,
        vipCampaign,
        birthdayCampaign,
      });
    }
  },

  _isLoyaltyingEmail:true,
  _loyaltyTransferEmail:"",
  _loyaltyTransferPhone1:"",
  _loyaltyTransferPhone2:"",
  _loyaltyTransferPhone3:"",
  _loyaltyLabels: [],
  _loyaltyTransferTabSelected: [],
  _loyaltyTransferPhoneIndex: 0,
  _loyaltyTransferEmailIndex: 0,
  _loyaltyTransferExternalIDIndex: 0,
  showLoyaltyTransfer: function()
  {
    this._didShowTransferLoyalty = true;

    var locMan = this.props.appManager.getLocalizationManager();
    this._loyaltyTransferEmail = "";
    this._loyaltyTransferPhone = "";
    var modes = this.state.transferLoyaltyCampaign.Modes;
    this._loyaltyLabels = [];
    this._loyaltyTransferTabSelected = [];
    var showSwitch = modes.length > 1;
    if( modes.length <= 0 ) return;
    
    for( var i = 0; i < modes.length; i++ )
    {
      if( modes[i] == "p" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("PHONE_OPTION"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferPhone(showSwitch));
        this._loyaltyTransferPhoneIndex = i;
      }
      else if( modes[i] == "e" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("EMAIL_OPTION"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferEmail(showSwitch));
        this._loyaltyTransferEmailIndex = i;
      }
      else if( modes[i] == "i" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("CARDID_OPTION", "Card ID"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferExternalID(showSwitch));
        this._loyaltyTransferExternalIDIndex = i;
      }
    }
    if( modes[0] == "p" )
    {
      this.showLoyaltyTransferPhone(showSwitch);
    }
    else if( modes[0] == "e" )
    {
      this.showLoyaltyTransferEmail(showSwitch);
    }
    else if( modes[0] == "i" )
    {
      this.showLoyaltyTransferExternalID(showSwitch);
    }
  },

  showLoyaltyTransferEmail : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingEmail = true;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                selectedIndex={thisThing._loyaltyTransferEmailIndex}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={styles.alertInnerContainer}>
            <ReUpField
              ref={(a)=>{thisThing._loyaltyTransferEmailField = a; if( a != null ) a.focus();}}
              key="email"
              appManager={appManager}
              keyboardType={"email-address"}
              onChangeText={(text) => {thisThing._loyaltyTransferEmail = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={emailLabel}
              floatingLabelEnabled={true}
              floatingLabelAniDuration={.1}
              returnKeyType={"done"}
              onSubmitEditing={thisThing.submitEmail}
              style={{flex:1}}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitEmail}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  submitEmail : function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var extras = this.props.extras;
    var appManager = this.props.appManager;
    var userID = this.props.extras.UserID;
    var locManager = appManager.getLocalizationManager();

    thisThing._loyaltyTransferEmailField.setIsInError(!appManager.isValidEmail(thisThing._loyaltyTransferEmail))
    if( appManager.isValidEmail(thisThing._loyaltyTransferEmail) )
    {
      thisThing._loyaltyTransferEmailField.setIsInError(false);
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.transferLoyaltyCampaign(appManager, thisThing._loyaltyTransferEmail, "", "", function(data)
      {
        appActions.setSpinnerShown(false);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody,[okButton],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
    else
    {
      thisThing._loyaltyTransferEmailField.setIsInError(true);
    }
  },

  showLoyaltyTransferPhone : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingEmail = false;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");

    var phoneSeparators = ["(",") "," - "]

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                selectedIndex={thisThing._loyaltyTransferPhoneIndex}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={[styles.alertInnerContainer, {paddingRight:8, alignItems:'center', height:70, justifyContent:'center'}]}>
            <ReUpText appManager={appManager} style={{marginTop:26, padding:4}}>{phoneSeparators[0]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone1=a; if( a != null ) a.focus();}}
              key="phone1"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone1 = text; if( text.length >= 3 ) thisThing._phone2.focus()}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"###"}
              maxLength={3}
              style={[styles.textField, {width:45}]}/>
            <ReUpText appManager={appManager} style={{flex:-1, marginTop:26, padding:4}}>{phoneSeparators[1]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone2=a}}
              key="phone2"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone2 = text; if( text.length >= 3 ) thisThing._phone3.focus()}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"###"}
              maxLength={3}
              style={[styles.textField, {width:45}]}/>
            <ReUpText appManager={appManager} style={{flex:-1, marginTop:26, padding:4}}>{phoneSeparators[2]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone3=a}}
              key="phone3"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone3 = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"####"}
              maxLength={4}
              onSubmitEditing={thisThing.submitPhone}
              returnKeyType={"done"}
              style={[styles.textField, {width:65}]}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitPhone}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  submitPhone : function()
  {
    var thisThing = this;
    var extras = this.props.extras;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var userID = this.props.extras.UserID;

    thisThing._phone1.setIsInError(thisThing._loyaltyTransferPhone1.length != 3);
    thisThing._phone2.setIsInError(thisThing._loyaltyTransferPhone2.length != 3);
    thisThing._phone3.setIsInError(thisThing._loyaltyTransferPhone3.length != 4);
    thisThing._loyaltyTransferPhone = thisThing._loyaltyTransferPhone1 + thisThing._loyaltyTransferPhone2 + thisThing._loyaltyTransferPhone3;

    if( thisThing._loyaltyTransferPhone1.length == 3 && thisThing._loyaltyTransferPhone2.length == 3 && thisThing._loyaltyTransferPhone3.length == 4 )
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.transferLoyaltyCampaign(appManager, "", thisThing._loyaltyTransferPhone, "", function(data)
      {
        appActions.setSpinnerShown(false);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody,[okButton],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
  },

  _loyaltyTransferExternalID: "",
  showLoyaltyTransferExternalID : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingExternalID = true;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
    var externalIDLabel = locMan.localizedStringForKey("CARDID_OPTION", "Card ID");

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                selectedIndex={thisThing._loyaltyTransferExternalIDIndex}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={styles.alertInnerContainer}>
            <ReUpField
              ref={(a)=>{thisThing._loyaltyTransferExternalIDField = a; if( a != null ) a.focus();}}
              key="externalID"
              appManager={appManager}
              autoCapitalize={"none"}
              onChangeText={(text) => {thisThing._loyaltyTransferExternalID = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={externalIDLabel}
              floatingLabelEnabled={true}
              floatingLabelAniDuration={.1}
              returnKeyType={"done"}
              onSubmitEditing={thisThing.submitExternalID}
              style={{flex:1}}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitExternalID}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  submitExternalID : function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var extras = this.props.extras;
    var appManager = this.props.appManager;
    var userID = this.props.extras.UserID;
    var locManager = appManager.getLocalizationManager();

    var isValidExternalID = thisThing._loyaltyTransferExternalID.length > 0;
    thisThing._loyaltyTransferExternalIDField.setIsInError(!isValidExternalID);
    if( isValidExternalID)
    {
      thisThing._loyaltyTransferExternalIDField.setIsInError(false);
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.transferLoyaltyCampaign(appManager, "", "", thisThing._loyaltyTransferExternalID, function(data)
      {
        appActions.setSpinnerShown(false);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody,[okButton],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
    else
    {
      thisThing._loyaltyTransferExternalIDField.setIsInError(true);
    }
  },

  _didShowVIPProgress: false,
  showVIPProgress: function(campaign)
  {
    this._didShowVIPProgress = true;

    var thisThing = this;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var generalColor = !appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
    var generalTitleColor = appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");

    var titleStyle = {marginTop:10, textAlign:'center', generalTitleColor};
    var bodyStyle = {textAlign:'center', margin:50, generalColor};


    var title = locMan.localizedStringForKey("VIP_ALERT_TITLE", "VIP Progress");
    var multiplier = (1 / campaign.Blob.DollarsPerPointMultiplier).toFixed(1);
    var progress = parseFloat(parseInt(campaign.Blob.ProgressPoints) / parseInt(campaign.Blob.GoalPoints));
    var isVIP = parseInt(campaign.Blob.ProgressPoints) >= parseInt(campaign.Blob.GoalPoints);
    var remainder = locMan.localizedPoints(parseInt(campaign.Blob.GoalPoints) - parseInt(campaign.Blob.ProgressPoints));
    var body = isVIP ?
      locMan.localizedStringForKeyAndParams("VIP_COMPLETE_STATEMENT", [multiplier], "You now earn %0%x points!") 
    : 
      locMan.localizedStringForKeyAndParams("VIP_PROGRESS_STATEMENT", [remainder], "Earn %0% more from purchases to be a VIP!");
    var buttonText = locMan.localizedStringForKey("GOT_IT_ALERT_BUTTON");
    var dimension = this.state.layout.width - 100;
    if( isVIP ) bodyStyle.color = profileMeterColor;
    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View style={{alignItems:'center', flexDirection:'column', justifyContent:'center', padding:10}}>
          <ReUpText appManager={appManager} isTitle={true} style={titleStyle}>
            {title}
          </ReUpText>
          {
            isVIP ?
              <ArcMeter appManager={appManager} 
                fgColor={profileMeterColor} bgColor={profileMeterBackgroundColor} 
                dimension={dimension} thickness={20} percentage={1}
                children={
                  <FadingView ref={(a)=>
                    {
                      if( a != null ) 
                      {
                        setTimeout(()=> a.setFadedOut(false), 500);
                        setTimeout(()=>
                        {
                          Animated.timing(
                           thisThing.state.starZoom,
                           {toValue: 1.3,
                           duration:300,
                           easing: Easing.out(Easing.ease)},
                          ).start(()=>
                          {
                            Animated.timing(
                             thisThing.state.starZoom,
                             {toValue: 1,
                             duration:300,
                             easing: Easing.in(Easing.ease)},
                            ).start(()=>
                            {
                              
                            });
                          });
                          
                        }, 500);
                      }
                    }} style={bodyStyle} animDuration={1000}>
                    <Animated.View style={{width:dimension/2, height:dimension/2, alignItems:'center', justifyContent:'center', flexDirection:'column', backgroundColor:'transparent',
                      transform: [{ scale:this.state.starZoom}]}}>
                      <Icon pointerEvents="none" name={"star-o"} size={dimension/2} color={profileMeterColor} style={{backgroundColor:'transparent', marginTop:Platform.OS == 'web' ? 0 : 18}} />
                      <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                        <ReUpText isTitle={true} appManager={appManager} style={{textAlign:'center', color:profileMeterColor}}>
                          {locMan.localizedStringForKey("VIP_BUTTON", "VIP")}
                        </ReUpText>
                      </View>
                    </Animated.View>
                  </FadingView>
                } /> 
            :
              <ArcMeter appManager={appManager} 
                fgColor={profileMeterColor} bgColor={profileMeterBackgroundColor} 
                dimension={dimension} thickness={20} percentage={progress}
                children={
                  <View style={bodyStyle}>
                    <ReUpText appManager={appManager} style={{textAlign:'center'}}>
                      {body}
                    </ReUpText>
                  </View>
                } /> 
          }
          {
            isVIP ?
              <View style={{margin:10}}>
                <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
                  {body}
                </ReUpText>
              </View>
            : null
          }
          <View style={{flexDirection:'row', marginTop:4}}>
            <ReUpButton onPress={thisThing.props.appActions.hideAlert} appManager={appManager} text={buttonText} style={[{margin:10, flex:1}]} />
          </View>
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  _referEmail:"",
  _referFirstName:"",
  _referLastName:"",
  _referFullName:"",
  showRefer: function()
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var pointsLocalized = locManager.localizedPoints(this.state.referCampaign.ReferrerPoints);
    var referTitle = this.props.referTitle == null ? locManager.localizedStringForKeyAndParams('REFER_BUTTON') : this.props.referTitle;
    var bundleID = appManager.getAppData()["Header"]["BundleID"];
    var link = bundleID.split('.')[2] + ".getreup.com";
    var body =  locManager.localizedStringForKeyAndParams("REFERRAL_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link], "Claim a free %0% towards a reward at %1%! Use referral code %2% to sign up. Download here: %3%");

    var shareOptions = {
      title: referTitle,
      subject: "Check out the " + appManager.appName + " app.",
      message: body
    };

    Share.open(shareOptions);
  },

  renderCampaign: function(campaign, index)
  {
    if( !campaign ) return null;

    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;

    var icon = null;
    var title = null;
    var body = null;
    var onPress = null;

    switch( campaign.Type )
    {
      case "UseCredit":
      {
        var feature = appManager.getFeatureForName("UseCredit");
        if( typeof feature === 'undefined' ) return null;
        icon = feature.data.icon.replace("fa-", "");
        title = feature.data.title;
        var dollarsPerPoint = campaign.Blob.DollarsPerPoint;
        body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3",[locManager.localizedPoints((1/dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)])
            + ('\n\n' + locManager.localizedStringForKey("EXCLUDED_PRODUCTS_STATEMENT"));
        onPress = ()=>{appActions.requestFeatureName("UseCredit")};
      }
      break;

      case "Referral":
      {
        var feature = appManager.getFeatureForName("ReferAFriend");
        if( typeof feature === 'undefined' ) return null;
        icon = feature.data.icon.replace("fa-", "");
        title = feature.data.title;
        body = "";
        if( typeof campaign.Blob.ReferrerPoints !== 'undefined' )
        {
          var pointsLocalized = locManager.localizedPoints(campaign.Blob.ReferrerPoints);
          body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT",[pointsLocalized]);
        }
        else if( typeof campaign.Blob.RewardName !== 'undefined' )
        {
          body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT",["one "+campaign.Blob.RewardName]);
        }
        onPress = ()=>{appActions.requestFeatureName("ReferAFriend")};
      }
      break;

      case "Checkin":
      {
        var checkInFeatureName = "CheckIn";
        var feature = appManager.getFeatureForName(checkInFeatureName);
        if( typeof feature === 'undefined' )
        {
          checkInFeatureName = "MyCard";
          feature = appManager.getFeatureForName(checkInFeatureName);
          if( typeof feature === 'undefined' ) return null;
        }
        icon = feature.data.icon.replace("fa-", "");
        title = feature.data.title;
        var dollarsPerPoint = campaign.Blob.DollarsPerPoint;

        body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3",[locManager.localizedPoints((1/dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)])
            + ('\n\n' + locManager.localizedStringForKey("EXCLUDED_PRODUCTS_STATEMENT"));
        onPress = feature.data.disableScan === true ? null : ()=>{appActions.requestFeatureName(checkInFeatureName)};
      }
      break;

      case "TransferLoyalty":
      {
        // return null if user has already transferred loyalty
        if( appManager.isLoggedIn() && appManager.currentUser()["HasTransferredLoyalty"] != "0" ) return null;

        icon = "exchange";
        title = locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON", "Transfer Loyalty");
        body = locManager.localizedStringForKey("LOYALTY_STATEMENT");
        onPress = ()=>{thisThing.showLoyaltyTransfer()};
      }
      break;

      case "VIP":
      {
        // return null if dollars per point is invalid
        if( typeof campaign.Blob.DollarsPerPointMultiplier === 'undefined' || campaign.Blob.DollarsPerPointMultiplier == 0 ) return null;

        var multiplier = (1 / campaign.Blob.DollarsPerPointMultiplier).toFixed(1);
        icon = "smile-o";
        title = locManager.localizedStringForKey("VIP_BUTTON", "VIP");
        body = locManager.localizedStringForKeyAndParams("VIP_STATEMENT", [multiplier], "Earn %0%x points as a VIP!");
        onPress = ()=>{thisThing.showVIPProgress(campaign)};
      }
      break;

      case "Birthday":
      {
        var feature = appManager.getFeatureForName("Birthday");
        if( typeof feature === 'undefined' ) return null;
        icon = feature.data.icon.replace("fa-", "");
        title = feature.data.title;
        var points = locManager.localizedPoints(campaign.Blob.Points);
        body = locManager.localizedStringForKeyAndParams("BIRTHDAY_STATEMENT", [points], "Earn %0% for entering your birthday."),
        onPress = ()=>{appActions.requestFeatureName("Birthday", {didSetBirthday:this.didSetBirthday})};
      }
      break;

      default:
        return null;
    }

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var buttonSecondaryColor = appManager.getColorForKey("ButtonSecondaryColor");
    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var buttonSecondaryTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");

    var other = {};
    if( onPress != null ) 
    {
      other.onPress = onPress;
      other.icon = "angle-right";
    }

    return (
        <View style={{overflow:'auto'}}>
      <ReUpButton appManager={appManager} isTertiary={true}
        iconColor={'red'}
        maskBorderRadius={0}
        style={{backgroundColor: 'transparent', padding: 0, alignSelf:'stretch', margin:0, width:-1, height:-1}}
        {...other}
      >
      <View style={{flex:1}}>
        <View style={{flexDirection:'row', alignItems:'center'}}>
          <View style={{margin:20, width:80, height:80, borderRadius:40, alignItems:'center', backgroundColor:buttonPrimaryColor, justifyContent:'center'}}>
            <View style={{marginTop:Platform.OS === "web" ? 0 : 5}}>
              { icon != null ? <Icon name={icon} size={44} color={buttonPrimaryTitleColor}/> : null }
            </View>
          </View>
          <View style={{marginRight:20, flex:1, flexDirection:'column'}}>
            <View>
              <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor}]}>
                {title}
              </ReUpText>
            </View>
            <View style={{height:4}} />
            <View style={{alignSelf:'stretch'}}>
              <ReUpText appManager={appManager} style={{color:generalTitleColor}}>
                {body}
              </ReUpText>
            </View>
          </View>
        </View>
      </View>
      <View style={{
        height:1,
        position:'absolute',
        left:0, right:0, bottom:0,
        backgroundColor:'#DADADA'
      }}/>
      </ReUpButton>
        </View>)
  },

  didSetBirthday: function()
  {
    this.setState({birthdayCampaign:null});
    if( typeof this.refs.ptr !== 'undefined' && this.refs.ptr != null ) this.refs.ptr.doOnlineUpdate()
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var campaignRows = [];

    var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
    var checkInFeatureData = appManager.getFeatureForName("CheckIn");
    var myCardFeatureData = appManager.getFeatureForName("MyCard");
    var referTitle = this.props.referTitle == null ? locManager.localizedStringForKeyAndParams('REFER_BUTTON') : this.props.referTitle;
    var referralCodeStatement = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + ": " + user.ReferralCode;

    if( this.state.useCreditCampaign != null && typeof useCreditFeatureData !== 'undefined' ) campaignRows.push({Type:"UseCredit", Blob:this.state.useCreditCampaign});
    if( this.state.checkInCampaign != null && (typeof checkInFeatureData !== 'undefined' || typeof myCardFeatureData !== 'undefined') ) campaignRows.push({Type:"Checkin", Blob:this.state.checkInCampaign});
    if( this.state.birthdayCampaign != null ) campaignRows.push({Type:"Birthday", Blob:this.state.birthdayCampaign});
    if( this.state.vipCampaign != null ) campaignRows.push({Type:"VIP", Blob:this.state.vipCampaign});
    if( this.state.referCampaign != null ) campaignRows.push({Type:"Referral", Blob:this.state.referCampaign});
    if( this.state.transferLoyaltyCampaign != null ) campaignRows.push({Type:"TransferLoyalty", Blob:this.state.transferLoyaltyCampaign});

    var generalColor = appManager.getColorForKey("GeneralColor");
    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor:generalColor}]} />
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <ReUpScrollView ref="ptr" bounces={true} featureName="EarnPoints" isEmpty={campaignRows.length <= 0} responder={this}>
        <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
          <View style={{alignSelf:'center'}}>
            <ReUpText appManager={appManager} style={[{margin:10, color:instructionTitleColor}]}>
              {pointsLeftStatement}
            </ReUpText>
          </View>
          <View style={{flex:1}} />
          <ReUpIconButton type={3}
            appManager={appManager}
            featureData={this.props.featureData}
            appActions={this.props.appActions}
            alertMessage={typeof this.props.featureData.instructions2 === 'undefined' ? null : this.props.featureData.instructions2}
            />
        </View>
        <ShadowView appManager={appManager} layout={this.state.layout} />
        {
          campaignRows.map((campaignRow, index)=>
          {
            return thisThing.renderCampaign(campaignRow, index);
          })
        }
        </ReUpScrollView>
      </View>
    );
  }
});

EarnPoints.getCards = function(featureData, appActions, data)
{
  if( typeof data.Campaigns === 'undefined' ) return [];
  var appManager = appActions._appManager;
  var locManager = appManager.getLocalizationManager();
  var isLoggedIn = appManager.isLoggedIn();

  var useCreditCampaign = null;
  var referCampaign = null;
  var checkInCampaign = null;
  var transferLoyaltyCampaign = null;
  var vipCampaign = null;
  var birthdayCampaign = null;
  for( var i = 0; i < data.Campaigns.length; i++ )
  {
    var campaign = data.Campaigns[i];
    if( campaign.Type == "UseCredit" ) useCreditCampaign = JSON.parse(campaign.CampaignBlob);
    if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
    if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
    if( campaign.Type == "TransferLoyalty" ) transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
    if( campaign.Type == "VIP" ) vipCampaign = JSON.parse(campaign.CampaignBlob);
    if( campaign.Type == "Birthday" ) birthdayCampaign = JSON.parse(campaign.CampaignBlob);
  }

  var cardCampaigns = []
  if( useCreditCampaign != null )
  {
    var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
    var dollarsPerPoint = useCreditCampaign.DollarsPerPoint;
    cardCampaigns.push({
      didSelect:()=>{appActions.requestFeatureName("UseCredit")},
      iconName:useCreditFeatureData.data.icon.replace("fa-", ""),
      title:useCreditFeatureData.data.title,
      body:locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3",[locManager.localizedPoints(Math.round(1/dollarsPerPoint)), locManager.localizedDollars(1)]),
    })
  }
  if( referCampaign != null )
  {
    var pointsLocalized = locManager.localizedPoints(referCampaign.ReferrerPoints);
    var referaFeatureData = appManager.getFeatureForName("ReferAFriend");
    cardCampaigns.push({
      didSelect:()=>{appActions.requestFeatureName("ReferAFriend")},
      iconName:referaFeatureData.data.icon.replace("fa-", ""),
      title:referaFeatureData.data.title,
      body:pointsLocalized
    })
  }
  if( checkInCampaign != null )
  {
    var checkInFeatureData = appManager.getFeatureForName("CheckIn");
    var myCardFeatureData = appManager.getFeatureForName("MyCard");
    var thisFeature = typeof checkInFeatureData !== 'undefined' ? checkInFeatureData : myCardFeatureData;
    var thisFeatureName = typeof checkInFeatureData !== 'undefined' ? "CheckIn" : "MyCard";
    var dollarsPerPoint = checkInCampaign.DollarsPerPoint;
    cardCampaigns.push({
      didSelect:()=>{appActions.requestFeatureName(thisFeatureName)},
      iconName:thisFeature.data.icon.replace("fa-", ""),
      title:thisFeature.data.title,
      body:locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3",[locManager.localizedPoints(Math.round(1/dollarsPerPoint)), locManager.localizedDollars(1)])
    })
  }
  if( transferLoyaltyCampaign != null )
  {
    if( !appManager.isLoggedIn() || appManager.currentUser()["HasTransferredLoyalty"] == "0" )
    {
      cardCampaigns.push({
        didSelect:()=>{appActions.requestFeatureName("EarnPoints", {shouldShowTransfer:true})},
        iconName:"exchange",
        title:locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON", "Transfer Loyalty"),
        body:locManager.localizedStringForKey("LOYALTY_STATEMENT")
      })
    }
  }
  if( vipCampaign != null )
  {
    var multiplier = (1 / vipCampaign.DollarsPerPointMultiplier).toFixed(1);
    cardCampaigns.push({
      didSelect:()=>{appActions.requestFeatureName("EarnPoints", {shouldShowVIP:true})},
      iconName:"smile-o",
      title:locManager.localizedStringForKey("VIP_BUTTON", "VIP"),
      body:locManager.localizedStringForKeyAndParams("VIP_STATEMENT", [multiplier], "Earn %0%x points per dollar as a VIP!")
    })
  }
  if( birthdayCampaign != null )
  {
    var feature = appManager.getFeatureForName("Birthday");
    if( typeof feature !== 'undefined' )
    {
      var points = locManager.localizedPoints(birthdayCampaign.Points);
      cardCampaigns.push({
        didSelect:()=>{appActions.requestFeatureName("Birthday", {didSetBirthday:()=>
        {
          for( var i = 0; i < data.Campaigns.length; i++ )
          {
            var campaign = data.Campaigns[i];
            if( campaign.Type == "Birthday" ) 
            {
              // remove bday and set data
              delete data.Campaigns[i];
              appManager.setData({Campaigns:data.Campaigns});
            }
          }
          NetworkManager.update( appManager, ["Campaigns"], ()=>{}, ()=>{} )
        }})},
        iconName:feature.data.icon.replace("fa-", ""),
        title:feature.data.title,
        body:locManager.localizedStringForKeyAndParams("BIRTHDAY_STATEMENT", [points], "Earn %0% for entering your birthday.")
      })
    }
  }

  var iconName = featureData.data.icon.replace("fa-", "")
  if( cardCampaigns.length > 0 )
  {
    return [{
      title : featureData.data.title,
      icon : iconName,
      cardType : 11,
      sortOrder : 24*60*60*1000,
      campaigns : cardCampaigns
    }];
  }


  var didSelect = function() {appActions.requestFeatureName("EarnPoints")};
  var body = featureData.data.tip;

  if( useCreditCampaign != null ) body = featureData.data.instructions2;
  else if( referCampaign != null )
  {
    var pointsLocalized = locManager.localizedPoints(referCampaign.ReferrerPoints);
    body = locManager.localizedStringForKey("EARN_POINTS_STATEMENT_2", pointsLocalized);
  }
  else if( checkInCampaign != null )
  {
    body = locManager.localizedStringForKey("CHECK_IN_STATEMENT");
  }
  else if( transferLoyaltyCampaign != null )
  {
    body = locManager.localizedStringForKey("LOYALTY_STATEMENT");
  }

  var sortOrder = 24*60*60*1000;
  if( isLoggedIn && (typeof data.Transactions !== 'undefined') && (data.Transactions.length > 0) )
  {
    var transaction = data.Transactions[0];
    var date = transaction.Timestamp;
    var thisDateTime = appManager.getTime(date);
    sortOrder = (new Date()).getTime() - thisDateTime - 10;
  }

  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : body,
    icon : iconName,
    cardType : 0,
    sortOrder : 24*60*60*1000
  }];
}


var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
    flex: 1
  },
  profileImage: {
    height:80,
    width:80,
    borderRadius:40,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:40,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  passwordContainer: {
    flexDirection:'row',
  },
  backgroundView: {
    position: 'absolute',
  },
  alertInnerContainer: {
    paddingTop:4,
    paddingLeft:10,
    paddingRight:10,
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'row',
  },
  referTypeContainer: {
    height:50,
    width:180,
    alignSelf:'center'
  },
  textField: {
    flex:1,
    height:50,
  },
  button: {
    justifyContent:'center',
    flex:1,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
});


EarnPoints.dataDependencies = ["Users","Campaigns","Transactions"];

module.exports = EarnPoints;



// WEBPACK FOOTER //
// ./src/EarnPoints.js